import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=eefba0fa&scoped=true"
import script from "./assignment.vue?vue&type=script&lang=js"
export * from "./assignment.vue?vue&type=script&lang=js"
import style0 from "./assignment.vue?vue&type=style&index=0&id=eefba0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefba0fa",
  null
  
)

export default component.exports